import type { ProductUpdatesEnvironment } from './interface';

export const environment: ProductUpdatesEnvironment = {
  production: false,
  angularProdMode: true,
  apiUrl: 'https://api.tellent.com/',
  baseUrl: 'https://updates.s.tellent.com',
  i18n: {
    defaultLocale: 'en',
    availableLocales: ['en', 'de', 'nl', 'fr'],
  },
  sentry: {
    dsn: 'https://ce62ef20bd51ad23442b27125500cc1d@o18167.ingest.us.sentry.io/4510696321712128',
    environmentName: 'development',
  },
};
